import { createTheme } from "@mui/material/styles"

export default createTheme({
  palette: {
    primary: {
      main: "#181818",
      contrastText: "#E6E2B1",
    },
  },
})
